import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from './../../common/dialog';

class SpeedTable extends Component {
    static propTypes = {
        speedTable: PropTypes.array,
        hideSpeedTable: PropTypes.func,
        handleUpdateSpeedTable: PropTypes.func,
        isSavingSpeedTable: PropTypes.bool,
        handleSaveSpeedTable: PropTypes.func,
        handleAddSpeedTable: PropTypes.func,
        handleDeleteSpeedTable: PropTypes.func,
        shrinkWrappingTypes: PropTypes.array
    };

    renderData() {
        const { speedTable, handleUpdateSpeedTable, handleDeleteSpeedTable, shrinkWrappingTypes } = this.props;

        let options = [];
        for (let i = 0; i < shrinkWrappingTypes.length; i++) {
            options.push(<option value={shrinkWrappingTypes[i]['id']}>{shrinkWrappingTypes[i]['name']}</option>);
        }

        return speedTable.map((speed, index) => {
            return (
                <tr key={index}>
                    <td>
                        <select name="" value={speed.shrink_wrapping_type_id} onChange={handleUpdateSpeedTable.bind(this, index, 'shrink_wrapping_type_id')}>
                            <option value="">Select option</option>
                            {options}
                        </select>
                    </td>
                    <td>
                        <input type="text" value={speed.time_per_package}
                            onChange={handleUpdateSpeedTable.bind(this, index, 'time_per_package')} />
                    </td>
                    <td>
                        <div className="action-icon">
                            <i className="fas fa-trash" onClick={handleDeleteSpeedTable.bind(this, index)} />
                        </div>
                    </td>
                </tr>
            );
        });
    }

    render() {
        const { hideSpeedTable, handleSaveSpeedTable, isSavingSpeedTable, handleAddSpeedTable } = this.props;

        let data = (
            <div>
                <table className="table table-sm table-striped data-table">
                    <thead>
                        <tr>
                            <th>Shrink Wrapping Type</th>
                            <th>Time/Package</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>{this.renderData()}</tbody>
                </table>
                <div className="add-button" onClick={handleAddSpeedTable} style={{ width: 120, fontSize: 13 }}><i className="fas fa-plus" /> Add Row</div>
            </div>
        );

        let saveButtonLabel = 'Save';
        if (isSavingSpeedTable) {
            saveButtonLabel = <i className="fas fa-circle-notch fa-spin" />;
        }

        let actions = [
            <button key="save-button" className="btn btn-light btn-sm action-button"
                onClick={handleSaveSpeedTable} disabled={isSavingSpeedTable}>{saveButtonLabel}</button>,
            <button key="close-button" className="btn btn-light btn-sm action-button-cancel" onClick={hideSpeedTable}>Close</button>
        ];
        return (
            <Dialog
                name="speed-table"
                modal={false}
                actions={actions}
                contentStyle={{ width: 800 }}
                bodyStyle={{ overflow: 'initial' }}
            >
                <div className="form-container">{data}</div>
            </Dialog>
        );
    }
}

export default SpeedTable;
